import { Component } from '@angular/core';

@Component({
  selector: 'app-notice-on-personal-data-protection',
  templateUrl: './notice-on-personal-data-protection.component.html',
  styleUrl: './notice-on-personal-data-protection.component.scss'
})
export class NoticeOnPersonalDataProtectionComponent {
  translocoPrefix: string ="personal.data.protection.notice.document.chapter."
}
